<ng-container *transloco="let loco; prefix: 'pages.comments'">
  <clr-datagrid [clrDgLoading]="loading">

    <clr-dg-column [clrDgField]="'entry'" [clrDgSortOrder]="descSort">{{ loco('from') }}</clr-dg-column>
    <clr-dg-column>{{ loco('note') }}</clr-dg-column>
    <clr-dg-column>{{ loco('contact') }}</clr-dg-column>
    <clr-dg-column>{{ loco('done') }}</clr-dg-column>
    <clr-dg-column [clrDgField]="'remember'">{{ loco('remember') }}</clr-dg-column>

    <clr-dg-placeholder>Aktuell keine Kommentare gefunden!</clr-dg-placeholder>
    <clr-dg-row *clrDgItems="let t of combinedCommentsDetails" >

      <clr-dg-cell>{{ t.entry | date: "dd.MM.yyyy" }}<br>({{ t.staffName }})</clr-dg-cell>
      <clr-dg-cell>{{ t.reason }}</clr-dg-cell>
      <clr-dg-cell [routerLink]="['/personen/details', t.person_id ]"><span *ngIf="t.person_id > 0"> {{ t.personName }}</span></clr-dg-cell>
      <clr-dg-cell>
          <cds-icon *ngIf="t.done && !trash" shape="dot-circle" (click)="setDone(t.id, false)"></cds-icon>
          <cds-icon *ngIf="!t.done && !trash" shape="circle" (click)="setDone(t.id, true)"></cds-icon>
          <cds-icon *ngIf="trash" class="trash-icon" shape="trash" (click)="deleteComment(t.id)"></cds-icon>
      </clr-dg-cell>
      <clr-dg-cell *ngIf="!t.remember || t.remember == '0000-00-00'"></clr-dg-cell>
      <clr-dg-cell class="clr-nowrap"
      *ngIf="t.remember && t.remember !== '0000-00-00'" [className]="findButtonClass(t.remember)" role="alert">
        <cds-icon *ngIf="dateDiff(t.remember) > 0" class="alert-icon" shape="exclamation-circle"></cds-icon>
        <cds-icon *ngIf="((dateDiff(t.remember) > -5) && (dateDiff(t.remember) <= 0))" class="alert-icon" shape="exclamation-triangle"></cds-icon>
        {{ t.remember | date: "dd.MM.yyyy" }}
      </clr-dg-cell>
    </clr-dg-row>

    <clr-dg-footer>
      <clr-dg-pagination #pagination [clrDgPageSize]="10">
        {{ pagination.firstItem + 1 }} - {{ pagination.lastItem + 1 }}
        von {{ combinedCommentsDetails.length }} Kommentar(en)
      </clr-dg-pagination>
    </clr-dg-footer>
  </clr-datagrid>
</ng-container>

<div class="comment-add-toggle" *ngIf="activeTab == 0">
  <button class="btn btn-sm btn-outline-primary" type="button" (click)="toggleAddForm()">
    {{ showAddForm ? 'Kommentar hinzufügen ausblenden' : 'Kommentar hinzufügen' }}
  </button>
</div>

<app-comment-add
  *ngIf="activeTab == 0 && showAddForm"
  [projectId]=projectId
  [subId]=subId
  [commentType]=commentType
  [companyId]=companyId
  (commentAdded)="refreshListAndSwitchTab(commentType, projectId, subId, status)">
</app-comment-add>
